import React from "react";

import { Box, IconButton } from "@material-ui/core";

import { FunctionField, Labeled, TextField, useNotify } from "react-admin";

import { CopyIcon } from "./iconography";

export function copyToClipboard(text, notify) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      notify && notify("Copied to clipboard");
    })
    .catch((error) => {
      notify && notify("Error copying to clipboard", { type: "error" });
      console.error("Error copying text to clipboard:", error);
    });
}

export const ClipboardTextField = ({
  record,
  source,
  label,
  format,
  ...props
}) => {
  if (!record) return null;

  const value = record[source];
  const displayValue =
    typeof format === "function" ? format(value, record) : value;

  return (
    <Box display="flex" alignItems="flex-end">
      <Labeled label={label ?? source}>
        {typeof format === "function" ? (
          <FunctionField
            {...props}
            source={source}
            render={() => displayValue}
            record={record}
          />
        ) : (
          <TextField {...props} source={source} record={record} />
        )}
      </Labeled>
      <CopyToClipboardButton text={displayValue} />
    </Box>
  );
};

export const CopyToClipboardButton = ({
  text,
  size = "small",
  fontSize = "medium",
  edge,
  mt,
  mb = 0.5,
  ml = 1,
  mr,
}) => {
  const notify = useNotify();

  const onPress = (event) => {
    event.stopPropagation();
    copyToClipboard(text, notify);
  };

  return (
    <Box component="span" display="inline-flex" mt={mt} mb={mb} ml={ml} mr={mr}>
      <IconButton size={size} edge={edge} onClick={onPress}>
        <CopyIcon fontSize={fontSize} />
      </IconButton>
    </Box>
  );
};
